import _ from 'lodash'
import { ammendDataWithStaticViewValues, convertHelpers, getStaticItems } from "../../common/convert"
import { gEnums } from "../../enums/globalEnums"
import { createRefPath_event } from '../../firestoreData/appData/appRefPaths'
import { getCollectionData } from "../../firestoreData/appData/collectionData"
import { getStartEnd } from "../../firestoreData/helpers/getRefProps"
import { saveToStaticViews } from '../../firestoreData/staticViews/updateStaticViews'
import { getGoogleSheetsData } from "../contexts/contextHelpers/googleSheetData"
import { postDataConstraits, postKeyConstraits } from "../contexts/contextHelpers/postDataConstraits"
import { responseReducers } from "./reducerHelpers/dispatchProps"

export const _secretDataName = 'secret'

const _showFetchType = false
const _showNewFetchType = false

const rts = {
  handleInit: 'handleInit',
  handleLoad_data: 'handleLoad_data',
  handleLoad_itemData: 'handleLoad_itemData',
  handleSecretData: 'handleSecretData',
  handleSetFetchData: 'handleSetFetchData',
  handleSetAlphaValue: 'handleSetAlphaValue',
  handleSetAlphabetValue: 'handleSetAlphabetValue',
  handleUpdateData: 'handleUpdateData',
  // handleGet_data: 'handleGet_data',
  // handleSet_dataResults: 'handleSet_dataResults',
  handleUpdate_staticView: 'handleUpdate_staticView',
}

const getSecretData = async (dr, propSectionKey) => {
  const ref = dr.collection(propSectionKey).doc(_secretDataName)
  const res = await ref.get()
  return res
}

export const dataReducer = (state, action) => {

  const { combinedListData, database_fns } = state

  const { dispatch, dataValue, isCombinedData, type, dataResultProps } = action
  const { name, singleDataItem, dataRef, dataId } = dataResultProps ?? {}

  const { handleUpdateData } = dataHandlers(dispatch)

  switch (type) {

    case rts.handleInit:

      return {
        ...state,
        isLoading: true,
        fetched: false,
      }

    // case rts.handleGet_data:
    //   // getDataData(action, handleSet_dataResults, database_fns)
    //   return { ...state }

    // case rts.handleSet_dataResults:
    //   return state
    //   return { ...state, dataResults: action.dataResults }

    case rts.handleLoad_itemData:
      const { itemDataInfo } = action
      const { itemData: itemData_info, itemDataName } = itemDataInfo ?? {}
      return {
        ...state,
        fetched: true,
        isLoading: false,
        uivi: itemDataName,
        [itemDataName]: itemData_info,
        viewListData: itemData_info,
        viewListDataCount: itemData_info ? Object.keys(itemData_info).length : 0,
      }

    case rts.handleLoad_data:

      const sing = { ...state.singles }
      let cd = { ...combinedListData }
      if (isCombinedData) { cd = { ...cd, ...dataValue } }

      if (singleDataItem && dataValue && Object.keys(dataValue).length === 1) { sing[name] = dataValue[Object.keys(dataValue)[0]] }

      return {
        ...state,
        [name]: dataValue,
        combinedListData: cd,
        dataId: dataId,
        dataName: name,
        dataRef,
        excludedData: action.excludedData,
        fetched: true,
        fsr: action.fsr,
        isLoading: false,
        singleDataItem,
        singles: sing,
        time_stamp: Date.now(),
        viewListData: dataValue,
        viewListDataCount: dataValue ? Object.keys(dataValue).length : 0,
        missingSvData: action.missingSvData
      }

    case rts.handleSecretData:

      const { dataRef: dr, dataName } = state
      const { secretProps } = action
      const { propSectionKey, itemData } = secretProps ?? {}
      const { key: itemKey } = itemData ?? {}

      getSecretData(dr, propSectionKey).then(res => {
        const secretItemData = res.data()
        const existingItemData = state[dataName][itemKey]
        const combinedItemData = { ...existingItemData, ...secretItemData }
        handleUpdateData(combinedItemData)
      })

      return { ...state }

    case rts.handleUpdateData:
      const { updateData } = action
      const vld = { ...state.viewListData }
      vld[updateData.key] = updateData
      return {
        ...state,
        [state.dataName]: action.updateData,
        viewListData: vld,
        viewListDataCount: vld ? Object.keys(vld).length : 0,
        time_stamp: Date.now()
      }

    case rts.handleSetAlphaValue:
      return {
        ...state,
        alphaValue: action.alphaValue
      }

    case rts.handleSetAlphabetValue:
      return {
        ...state,
        alphabetValue: action.alphabetValue
      }

    case rts.handleSetFetchData:
      return {
        ...state,
        fetchData: action.fetchData
      }

    case rts.handleUpdate_staticView:
      updateStaticView(action.actionItem)
      return { ...state }

    case rts.updateSuccess:
    case rts.updateSuccessAlt:
    case rts.updateError:
      return responseReducers(state, action, { [name]: dataValue, fetched: true })

    default:
      return { ...state }
  }
}

export const dataInitialState = (initState) => {
  const { database_fns, diKey, isCombinedData, isSettingData, itemListData, uivi, updateProps, viewItem, pageImages } = initState ?? {}
  return {
    // alphabetValue: 65,
    database_fns,
    combinedListData: {},
    confirmation: null,
    diKey,
    isCombinedData,
    isSettingData,
    itemListData,
    pageImages,
    singleDataItem: false,
    singles: {},
    uivi,
    updateProps,
    viewItem,
  }
};

export const dataHandlers = (dispatch) => {
  return {
    handleLoad_itemData: (itemDataInfo) => { dispatch({ type: rts.handleLoad_itemData, itemDataInfo }) },
    handleInit: () => { dispatch({ type: rts.handleInit }) },
    // handleGet_data: (getProps) => { dispatch({ type: rts.handleGet_data, dispatch, getProps }) },
    // handleSet_dataResults: (dataResults) => { dispatch({ type: rts.handleSet_dataResults, dispatch, dataResults }) },
    handleLoad_data: (dataValue, dataResultProps, fsr, excludedData, missingSvData) => { dispatch({ type: rts.handleLoad_data, dataValue, dataResultProps, fsr, excludedData, missingSvData }) },
    handleSecretData: (secretProps) => { dispatch({ type: rts.handleSecretData, dispatch, secretProps }) },
    handleSetAlphaValue: (alphaValue) => { dispatch({ type: rts.handleSetAlphaValue, alphaValue }) },
    handleSetAlphabetValue: (alphabetValue) => { dispatch({ type: rts.handleSetAlphabetValue, alphabetValue }) },
    handleSetFetchData: (fetchData) => { dispatch({ type: rts.handleSetFetchData, fetchData }) },
    handleUpdateData: (updateData) => { dispatch({ type: rts.handleUpdateData, updateData }) },
    handleUpdate_staticView: (actionItem) => { dispatch({ type: rts.handleUpdate_staticView, dispatch, actionItem }) },
  }
}

const getDataData = (action, callback, database_fns) => {

  const cb = (dataValue, dataResultProps, refProps, existingDatas) => {
    // console.log('dataValue!!!', dataValue)
    // console.log('itemData', action?.getProps?.itemData)
    filterTheData(action, dataValue, dataResultProps, refProps, existingDatas, callback)
  }

  getTheData(action, cb, database_fns)

}

const getTheData = async (action, callback, database_fns) => {

  const { getProps } = action

  const {
    _dataResultProps,
    _dataSourceType,
    appDataDocuments,
    appDataSource,
    cache_event,
    cache_eventInfo,
    currentPageData,
    dataCaptionProps,
    dataCollection,
    delayData,
    demo_state,
    documentDependencies,
    dProps,
    eventItemData,
    fetchData,
    globalAppData,
    googleModeType,
    googleSheetsData,
    isAppData,
    otherView,
    pageData_state,
    refProps,
    returnFsr,
    staticViews,
    trueViewKey,
    uivi,
    view,
    viewKey,
  } = getProps ?? {}

  const altProps = {
    database_fns,
    appDataDocuments,
    callback,
    currentPageData,
    dataCaptionProps,
    eventItemData,
    returnFsr,
    appDataSource,
  }

  const { fetchExistingData } = appDataSource ?? {}

  const { demoOn, demoPreview } = demo_state ?? {}
  const { projectData } = demoPreview ?? {}
  const { dataCollections } = projectData ?? {}

  if (demoOn && dataCollections) {
    const { hasExisting: _hasExistingDemoData, existingData: _existingDemoData } = getExistingAppData(dataCollections, view, viewKey, uivi)
    callback(_existingDemoData, _dataResultProps, refProps)
    return
  }

  // pick the dataSourceType  
  switch (_dataSourceType) {

    case gEnums.dataSourceTypes.component:
      callback({}, _dataResultProps)
      break;

    case gEnums.dataSourceTypes.googleSheet:

      let { googleItemData, noGoogleSheet } = getGoogleSheetsData({ uivi, googleSheetsData, googleModeType, dataSourceType: _dataSourceType, view, viewKey, refProps })

      if (noGoogleSheet) {
        getCollectionData(dProps, altProps)
      } else {
        if (googleItemData) {
          if (trueViewKey && googleItemData[trueViewKey]) {
            callback({ [trueViewKey]: googleItemData[trueViewKey] }, _dataResultProps, refProps)
          } else {
            callback(googleItemData, _dataResultProps, refProps)
          }
        }
      }

      break;

    default:
      if (dataCollection) {

        if (isAppData) { // APP DATA
          const staticViewItems = ammendStatic(staticViews, dataCollection)
          callback(staticViewItems, _dataResultProps)
        } else {
          if ((!delayData || fetchData) && otherView !== 'add') {
            const { eventPageKey } = refProps ?? {}

            const { hasExisting: _hasExistingAppData, existingData: _existingAppData } = getExistingAppData(globalAppData, view, viewKey, uivi)
            const { hasExisting: _hasExistingCacheData, existingData: _existingCacheData } = getExistingCacheData(cache_eventInfo, view, viewKey, uivi, cache_event)

            const existingDatas = {
              appData: _hasExistingAppData,
              cacheData: _hasExistingCacheData,
            }

            if (documentDependencies && documentDependencies.includes(view)) {
              const { singles } = pageData_state
              const dd = getDependencyData(documentDependencies, singles, dataCollection, trueViewKey)
              callback(dd, _dataResultProps)
            } else {
              if (fetchExistingData) {
                if (_hasExistingAppData && _existingAppData) {
                  _showFetchType && console.log('DB >> fetchType >> ', 'hasExistingAppData', dataCollection)
                  callback(_existingAppData, _dataResultProps, refProps, existingDatas)
                } else if (_hasExistingCacheData && _existingCacheData) {
                  _showFetchType && console.log('DB >> fetchType >> ', 'hasExistingCacheData', dataCollection, viewKey)
                  callback(_existingCacheData, _dataResultProps, refProps, existingDatas)
                } else {
                  _showFetchType && console.log('DB >> refreshing >> ', dataCollection)
                  getCollectionData(dProps, altProps, existingDatas)
                }
              } else {
                _showFetchType && console.log('fetchType', 'getCollectionData', dataCollection)
                _showNewFetchType && console.log('NEW', 'getCollectionData')
                getCollectionData(dProps, altProps, existingDatas)
              }
            }
          } else {
            callback({}, _dataResultProps)
          }
        }
      }
      break;
  }
}

const getExistingAppData = (data, view, viewKey, uivi) => {

  let hasExisting;
  let _existingData;
  let existingData;

  if (data && data[uivi]) {
    _existingData = data[uivi]
    if (viewKey) {
      if (_existingData && _existingData[viewKey]) {
        existingData = {
          [viewKey]: _existingData[viewKey]
        }
        hasExisting = true
      } else if (view !== uivi) {
        existingData = _existingData
        hasExisting = true
      }
    } else {
      existingData = _existingData
      hasExisting = true
    }
  }

  return { hasExisting, existingData }

}

const getExistingCacheData = (cache_eventInfo, view, viewKey, uivi, cache_event) => {

  const { cache_collections, cache_collection_timeStampsInfo } = cache_eventInfo ?? {}

  let hasExisting = false;
  let _existingData;
  let existingData;

  switch (view) {
    case 'home':
      if (cache_event && cache_event[view] && cache_event[view][uivi]) {
        _existingData = cache_event[view][uivi]
        hasExisting = true
      }
      break;
    default:

      const eventDataTimeStamp_uivi = cache_collection_timeStampsInfo && cache_collection_timeStampsInfo[uivi]
      const { needed } = eventDataTimeStamp_uivi ?? {}

      if (!needed) {
        if (cache_collections && cache_collections[uivi]) {
          _existingData = cache_collections[uivi]
          if (viewKey) {
            if (_existingData && _existingData[viewKey]) {
              existingData = {
                [viewKey]: _existingData[viewKey]
              }
              hasExisting = true
            } else if (view !== uivi) {
              existingData = _existingData
              hasExisting = true
            }
          } else {
            existingData = _existingData
            hasExisting = true
          }
        }
      }
  }

  return { hasExisting, existingData }

}

const filterTheData = (action, dataValue, dataResultProps, refProps, existingDatas, callback) => {

  const { getProps } = action

  const {
    _appDataSourceType,
    _dataSourceType,
    _usePostConstraint,
    appComponentStateCollection,
    appDataLinks,
    appDataSource,
    dataCollection,
    dataCollectionName,
    dataOverrideOn,
    dProps,
    fsr,
    hideInactiveItems_do,
    isSuperAdmin,
    staticViews_gs,
    staticViews,
    uivi,
    useSingleCollectionDocuments,
    viewItem_page,
  } = getProps

  const { useAppDataLinks, useAppDataDocuments } = appDataSource ?? {}

  let _dataValue = dataValue

  const _uivi = dataCollectionName ? dataCollectionName : uivi

  if (useSingleCollectionDocuments && dataValue && dataValue[_uivi] && dataValue[_uivi][_uivi]) {
    _dataValue = dataValue[_uivi][_uivi]
  }

  const { refProps: refProps_dp } = dProps ?? {}
  const _refProps = refProps ? refProps : refProps_dp
  const { whereOpts } = _refProps ?? {}

  if (viewItem_page) {
    if (_appDataSourceType === gEnums.dataSourceTypes.googleSheet) {
      ammendDataWithStaticViewValues(staticViews_gs, _dataValue)
    } else {
      ammendDataWithStaticViewValues(staticViews, _dataValue)
    }
  }

  if (useAppDataLinks && appDataLinks && appDataLinks[uivi]) {
    const appDataLink = appDataLinks[uivi] // all attendees
    const _dataItems = _dataValue
    _.forEach(_dataItems, (dataItem, dataItemKey) => {
      if (appDataLink[dataItemKey]) {
        const appDataLinkItem = appDataLink[dataItemKey]
        _.forEach(appDataLinkItem, (linkItems, linkItemKey) => {
          if (dataItem && dataItem[linkItemKey]) {
            dataItem[linkItemKey] = linkItems
          }
        })
      }
    })
  }


  // const { whereOpts } = fsr ?? {}
  const { posts: wherez, dataKeys } = whereOpts ?? {}

  // the postDataConstraits are only filtered in certain cases 
  const _usePostConstraints = !dataOverrideOn && (_usePostConstraint || hideInactiveItems_do || useAppDataDocuments) && (wherez && wherez.length > 0)

  let { postData: _postData, excludedData } = _usePostConstraints ? postDataConstraits(whereOpts, _dataValue, _uivi) : { postData: _dataValue }

  // console.log('_postData- NORM', _uivi, _postData)

  if (dataKeys && dataKeys.length > 0) { _postData = postKeyConstraits(fsr, _postData) }

  let missingSvData = {}
  if (isSuperAdmin) {
    const _staticView = staticViews && staticViews[dataCollection] ? staticViews[dataCollection] : {}
    missingSvData = _dataValue ? _.difference(Object.keys(_dataValue), Object.keys(_staticView)) : {};
  }

  callback({ _postData, _dataSourceType, dataValue: _dataValue, refProps: _refProps, dataResultProps, dataCollection, missingSvData, excludedData, appComponentStateCollection, existingDatas })

}


const ammendStatic = (staticViews, uivi) => {
  const vitStaticData = staticViews[uivi]
  if (vitStaticData) {
    Object.keys(vitStaticData).forEach(key => {
      if (_.isObject(vitStaticData[key])) {
        vitStaticData[key].id = key
        vitStaticData[key]._itemKey = key
      }
    })
    delete vitStaticData.id
    delete vitStaticData.uid
  }

  return vitStaticData
}

const getDependencyData = (documentDependencies, singles, uivi, viewKey) => {
  let d;
  documentDependencies.forEach(dd => {
    if (singles[dd]) {
      d = singles[dd]
    } else if (d && d[dd] && d[dd][viewKey]) {
      d = d[dd][viewKey]
    }
  })
  d = d ? d[uivi] : null
  return d
}

const updateStaticView = (actionItem) => {

  const { pathViews, viewListData, staticView, uniqueProps, viewItem } = actionItem
  const staticItems = getStaticItems(Object.values(viewListData), 'name', uniqueProps)

  convertHelpers.createItemKeys(staticView)
  convertHelpers.createItemKeys(staticItems)

  const sorted = {
    staticView: _.sortBy(staticView, 'name'),
    staticItems: _.sortBy(staticItems, 'name')
  }

  const areEqual = _.isEqualWith(sorted.staticItems, sorted.staticView, (obj1, obj2) => {
    return _.isEqual(_.sortBy(_.toPairs(obj1)), _.sortBy(_.toPairs(obj2)));
  });

  const missing = {
    staticView: _.differenceWith(sorted.staticItems, sorted.staticView, _.isEqual),
    staticItems: _.differenceWith(sorted.staticView, sorted.staticItems, _.isEqual)
  }

  if (!areEqual && missing.staticView.length > 0) {
    console.log('Updating the static views', viewItem.key, actionItem)
    convertHelpers.removeItemKeys(staticItems)
    saveToStaticViews(pathViews, viewItem, staticItems, viewItem.key)
  }
}